<template>
  <div class="modelcover">
    <div class="tips">
    	<div class="modal">
    		<div class="flex" style="justify-content: space-between;">
    			<span class="font18">交卷</span>
    			<img src="../assets/img/closewin.png" width="18" height="18" style="cursor: pointer;" @click="handleCloseTips" >
    		</div>
    		<div class="line">

    		</div>
    		<div class="text-center" style="font-size: 16px;margin-top: 30px;">
    			共有试题<span style="color: #0075ff;">{{listlength}}</span>道，已做<span style="color: #f8931f;">{{donelist}}</span>题。您确认要交卷吗？
    		</div>
    		<div class="line" style="margin-top: 30px;">

    		</div>
    		<div class="btnwrap flex" style="justify-content: flex-end;">
    			<span class="btn confirm " @click="handleSubmit()">确定交卷</span>
    			<span class="btn cancel" @click="handleCloseTips" >再检查一下</span>
    		</div>
    	</div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Footer',
    props:{
      listlength:{
          type:Number,
          default:()=>0
      },
      donelist:{
          type:Number,
          default:()=>0
      }
    },
    data () {
      return {

      }
    },
    methods:{
      handleCloseTips(){
        this.$emit('handleCloseTips')
      },
      handleSubmit(){
          this.$emit('handleSubmit')
      }
    },
    created(){

    }
  }
</script>

<style scoped="">
  .modelcover {
    width: 100%;
        height: 100%;
        background-color: rgba(34, 34, 34, 0.5);
        display: flex;
        justify-content: center;
        align-items: center;
        top: 0;
        position: fixed;
        left: 0;
        z-index: 1988;
  }
  .modal {
  		width: 500px;
  	    background-color: rgba(255, 255, 255, 1);
  	    position: relative;
  		padding: 30px;
  }
  .btnwrap .btn {
  	width: 120px;
  	height: 40px;
  	text-align: center;
  	line-height: 40px;
    cursor: pointer;
  }
  .cancel {
  	border: 1px solid #efefef;
  	color: #000;
  	background-color: #efefef;
  	margin-left: 15px;
  }
  .confirm {
  	background-color: #4fa7ff;
  	color: #fff;
  	margin-left: 25px;
  }
  .line {
  	height: 1px;
  	background-color: #ccc;
  	margin: 15px -30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/submtiquestiontips.vue